import axios from '../utils/axios'

export function carousellist(params) {//验证码
  return axios.post('/Carousel/carousellist', params);
}
